import { TodayCounts } from '../../services/today-badge-counts.service';

export class GetTodayBadgeCounts {
  static readonly type = '[TodayBadgeCounts] GetTodayBadgeCounts';
  constructor(
    public lenderUserId: number,
  ) {}
}

export class UpdateCounts {
  static readonly type = '[TodayBadgeCounts] UpdateCounts';
  constructor(
    public counts: TodayCounts
  ) {}
}
export class UserActionItemCompleted {
  static readonly type = '[TodayBadgeCounts] TodayUserActionItemCompleted';
  constructor(
    public type: string,
    public taskTypeId: number,
  ) {}
}

export class MissedCallMarkedRead {
  static readonly type = '[TodayBadgeCounts] MissedCallMarkedRead';
  constructor(
    public callId: number
  ) {}
}

export class MarkAllMissedCallsRead {
  static readonly type = '[TodayBadgeCounts] MarkAllMissedCallsRead';
  constructor(
    public lenderUserId: number
  ) {}
}
